import React from "react";

import { Grid, Card, CardContent,useMediaQuery } from "@mui/material";
import DashboardScreen from "./DashboardScreen";

export default function Dashboard() {
  const isMobile = useMediaQuery('(max-width:768px)');
  return (
    <React.Fragment>
      <div className={isMobile ? 'dataOutletIsMobile' : 'dataoutlet'}>
        <Grid container>
          <Grid item xs={12} sm={12}>
            <div className={isMobile ? 'formSectionIsMobile' : 'formSection'}>
              <Card variant="none">
                <CardContent style={{padding:isMobile && "0px"}}>
                  <DashboardScreen />
                </CardContent>
              </Card>
            </div>
          </Grid>
        </Grid>
      </div>
    </React.Fragment>
  );
}
